<section
  class="faq-section"
  id="faq"
  [ngClass]="{ 'mt-80 mb-60': verticalMargin() }">
  <!-- section title -->
  <h3 class="faq-section__title">{{ 'global.faq' | translate }}</h3>
  <!-- accordion list -->
  <pwj-accordion
    class="faq-section__accordion"
    [accordionData]="faqData()"></pwj-accordion>
</section>
